import { Component, EventEmitter, Output } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { CustomModalService } from '@piqet-angular/shared';
import { AdministratorService } from 'libs/data/src/lib/services/administrator/administrator.service';

@Component({
  selector: 'piqet-angular-new-processing-custom-truck',
  templateUrl: './new-processing-custom-truck.component.html',
  styleUrls: ['./new-processing-custom-truck.component.scss'],
})
export class NewProcessingCustomTruckComponent {
  headerData: any;
  headerName = '';
  modalLabel: any;
  processingCustomtruckData: any;
  processingCustomtruckForm!: FormGroup;
  processingCustomtruckAddEditForm!: FormGroup;
  submitted = false;
  processingCustomtruckList: any;
  regionList: any;
  regionData: any;
  selectRegion: any;
  setIndicatorData: any;
  indicatorList: any;
  isHideDropDown!: boolean;
  isDisabledDropDown!: boolean;
  @Output() saveNewProcessingCustomTruckEvent = new EventEmitter<any>();

  constructor(
    private formBuilder: FormBuilder,
    private modal: CustomModalService,
    private administratorService: AdministratorService
  ) {
    this.modalLabel = this.modal?.modalService?.config?.initialState?.['label'];
    this.processingCustomtruckData =
      this.modal?.modalService?.config?.initialState?.['newProcessingCustomTruckData'];
    this.isDisabledDropDown = this.modalLabel == 'Review custom truck detail' ? true : false;
    const placeHoldertruck = {
      description: [],
      childItems: [
        {
          name: 'Custom Truck',
        },
      ],
    };

    const newtrucklist = [placeHoldertruck].concat(
      this.processingCustomtruckData.truckProcessItems
    );

    this.indicatorList = this.processingCustomtruckData.indicatiorList;
    this.processingCustomtruckList = newtrucklist;
  }
  ngOnInit(): void {
    const form = [];
    for (let i = 0; i < this.indicatorList.length; i++) {
      form[this.indicatorList[i].name] = new FormControl(
        this.processingCustomtruckData.indicatiorList[i].defaultValue || 0,
        Validators.required
      );
    }
    this.processingCustomtruckForm = new FormGroup(form);
    this.processingCustomtruckAddEditForm = this.formBuilder.group({
      truck: [this.processingCustomtruckData.truckId || null, Validators.required],
    });
  }

  onClose() {
    this.modal.close();
  }

  commonInputSearch(term: string, item: any) {
    return item.name.toLowerCase().includes(term.toLowerCase());
  }

  onSave() {
    this.submitted = true;
    if (
      this.processingCustomtruckAddEditForm.status == 'VALID' &&
      this.processingCustomtruckForm.status == 'VALID'
    ) {
      const entires = Object.entries(this.processingCustomtruckForm.value);
      const resultArray: any = [];
      let i = {};
      const entiresArray = this.processingCustomtruckData.indicatiorList.map(
        (obj: any, index: any) => ({
          ...obj,
          ...entires[index],
        })
      );
      entiresArray.forEach((event: any, index: any) => {
        i = {
          indicatorId: event.indicatorId,
          name: event.name,
          unit: event.unit,
          defaultValue: event[1],
          equivalencyUnits: event.equivalencyUnits,
          multiplier: event.multiplier,
        };
        resultArray.push(i);
      });
      const processingCustomTruckPayload = {
        truckId:
          this.processingCustomtruckAddEditForm.controls['truck'].value ||
          this.processingCustomtruckData.truckId,
        indicatiorList: resultArray,
      };
      this.saveNewProcessingCustomTruckEvent.emit(processingCustomTruckPayload);
      this.onClose();
    }
  }
}
